<template>
  <div class="flex m-8 justify-start flex-wrap">
    <div class="md:max-w-xs w-full mb-4 md:mb-0">
      <p class="pb-2 text-gray-500 font-medium">Nuevo escenario</p>
      <p class="text-sm text-gray-400">
        Ingresa aqui la información del nuevo escenario a crear.
      </p>
    </div>
    <div class="flex-1 md:ml-5">
      <div class="flex w-full flex-wrap">
        <div class="w-full mb-4">
          <p class="text-gray-500 font-medium pb-2">
            Puertas
          </p>
        </div>
        <div class="w-full lg:w-1/2 mb-4 lg:px-2">
          <div class="flex">
            <label class="block text-sm font-medium leading-5 text-gray-700"
              >Material</label
            >
            <div
              v-if="$v.form.doors_are_made_of_glass.$error"
              class="pointer-events-none pl-2"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
          <select-buttons
            class="mt-1"
            v-model="$v.form.doors_are_made_of_glass.$model"
            :options="doorsOptions"
          ></select-buttons>
        </div>

        <div
          class="w-full lg:w-1/2 mb-4 lg:px-2"
          v-if="!form.doors_are_made_of_glass"
        >
          <label
            for="doors_material"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Material</label
          >
          <div class="mt-1 relative rounded-md shadow-sm">
            <select
              id="doors_material"
              aria-label="Material"
              v-model.trim="$v.form.doors_material.$model"
              required
              :class="{
                'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
                  $v.form.doors_material.$error,
              }"
              class="form-select relative block w-full rounded-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
              <option value="" disabled>Selecciona un material</option>
              <option
                v-for="doorMaterial in sortedDoorMaterials"
                :key="doorMaterial.id"
                :value="doorMaterial.id"
                >{{ doorMaterial.name }}</option
              >
            </select>
            <div
              class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
              v-if="$v.form.doors_material.$error"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>

        <!-- Glass -->
        <div class="w-full border-t border-gray-200 my-6"></div>

        <div class="w-full mb-4">
          <p class="text-gray-500 font-medium pb-2">
            Ventanas
          </p>
        </div>

        <div class="w-full lg:w-1/2 mb-4 lg:px-2">
          <label
            for="glass_material"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Material</label
          >
          <div class="mt-1 relative rounded-md shadow-sm">
            <select
              id="glass_material"
              aria-label="Material"
              v-model.trim="$v.form.glass_material.$model"
              required
              :class="{
                'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
                  $v.form.glass_material.$error,
              }"
              class="form-select relative block w-full rounded-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
              <option value="" disabled>Selecciona un material</option>
              <option
                v-for="glassMaterial in sortedWindowMaterials"
                :key="glassMaterial.id"
                :value="glassMaterial.id"
                >{{ glassMaterial.name }}</option
              >
            </select>
            <div
              class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
              v-if="$v.form.glass_material.$error"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
        <!-- Glass -->

        <!-- Walls -->
        <div class="w-full border-t border-gray-200 my-6"></div>
        <div class="w-full mb-4">
          <p class="text-gray-500 font-medium pb-2">
            Muros
          </p>
        </div>
        <div class="w-full lg:w-1/2 mb-4 lg:px-2">
          <label
            for="wall_material"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Material</label
          >
          <div class="mt-1 relative rounded-md shadow-sm">
            <select
              id="wall_material"
              aria-label="Material"
              required
              v-model.trim="$v.form.wall_material.$model"
              :class="{
                'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
                  $v.form.wall_material.$error,
              }"
              class="form-select relative block w-full rounded-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
              <option value="" disabled>Selecciona un material</option>
              <option
                v-for="wallMaterial in sortedWallMaterials"
                :key="wallMaterial.id"
                :value="wallMaterial.id"
                >{{ wallMaterial.name }}</option
              >
            </select>
            <div
              class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
              v-if="$v.form.wall_material.$error"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>

        <div class="w-full lg:w-1/2 mb-4 lg:px-2">
          <label
            for="wall_interior_finishes"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Acabado interior</label
          >
          <div class="mt-1 relative rounded-md shadow-sm">
            <select
              id="wall_interior_finishes"
              aria-label="Acabado"
              required
              v-model.trim="$v.form.wall_interior_finishes.$model"
              :class="{
                'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
                  $v.form.wall_interior_finishes.$error,
              }"
              class="form-select relative block w-full rounded-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
              <option value="" disabled>Selecciona un acabado</option>
              <option
                v-for="wallsInteriorFinish in sortedComposite"
                :key="wallsInteriorFinish.id"
                :value="wallsInteriorFinish.id"
                >{{ wallsInteriorFinish.name }}</option
              >
            </select>
            <div
              class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
              v-if="$v.form.wall_interior_finishes.$error"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>

        <div class="w-full lg:w-1/2 mb-4 lg:px-2">
          <label
            for="wall_exterior_finishes"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Acabado exterior</label
          >
          <div class="mt-1 relative rounded-md shadow-sm">
            <select
              id="wall_exterior_finishes"
              aria-label="Acabado"
              required
              v-model.trim="$v.form.wall_exterior_finishes.$model"
              :class="{
                'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
                  $v.form.wall_exterior_finishes.$error,
              }"
              class="form-select relative block w-full rounded-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
              <option value="" disabled>Selecciona un acabado</option>
              <option
                v-for="wallsExteriorFinish in sortedComposite"
                :key="wallsExteriorFinish.id"
                :value="wallsExteriorFinish.id"
                >{{ wallsExteriorFinish.name }}</option
              >
            </select>
            <div
              class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
              v-if="$v.form.wall_exterior_finishes.$error"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
        <!-- End walls -->

        <!-- Slab -->
        <div class="w-full border-t border-gray-200 my-6"></div>
        <div class="w-full mb-4">
          <p class="text-gray-500 font-medium pb-2">
            Losa
          </p>
        </div>

        <div class="w-full lg:w-1/2 mb-4 lg:px-2">
          <label
            for="slab_material"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Material</label
          >
          <div class="mt-1 relative rounded-md shadow-sm">
            <select
              id="slab_material"
              aria-label="Material"
              required
              v-model.trim="$v.form.slab_material.$model"
              :class="{
                'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
                  $v.form.slab_material.$error,
              }"
              class="form-select relative block w-full rounded-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
              <option value="" disabled>Selecciona un material</option>
              <option
                v-for="slabMaterial in sortedSlabMaterials"
                :key="slabMaterial.id"
                :value="slabMaterial.id"
                >{{ slabMaterial.name }}</option
              >
            </select>
            <div
              class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
              v-if="$v.form.slab_material.$error"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
        <div class="w-full lg:w-1/2 mb-4 lg:px-2">
          <label
            for="slab_interior_finishes"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Acabado interior</label
          >
          <div class="mt-1 relative rounded-md shadow-sm">
            <select
              id="slab_interior_finishes"
              aria-label="Acabado"
              required
              v-model="form.slab_interior_finishes"
              v-model.trim="$v.form.slab_interior_finishes.$model"
              :class="{
                'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
                  $v.form.slab_interior_finishes.$error,
              }"
              class="form-select relative block w-full rounded-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
              <option value="" disabled>Selecciona un acabado</option>
              <option
                v-for="slabInteriorFinish in sortedComposite"
                :key="slabInteriorFinish.id"
                :value="slabInteriorFinish.id"
                >{{ slabInteriorFinish.name }}</option
              >
            </select>
            <div
              class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
              v-if="$v.form.slab_interior_finishes.$error"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>

        <div class="w-full lg:w-1/2 mb-4 lg:px-2">
          <label
            for="slab_exterior_finishes"
            class="block text-sm font-medium leading-5 text-gray-700"
            >Acabado exterior</label
          >
          <div class="mt-1 relative rounded-md shadow-sm">
            <select
              id="slab_exterior_finishes"
              aria-label="Acabado"
              required
              v-model="form.slab_exterior_finishes"
              v-model.trim="$v.form.slab_exterior_finishes.$model"
              :class="{
                'pr-10 border-red-300 text-red-900 placeholder-red-300 focus:border-red-300 focus:shadow-outline-red':
                  $v.form.slab_exterior_finishes.$error,
              }"
              class="form-select relative block w-full rounded-md bg-transparent focus:z-10 transition ease-in-out duration-150 sm:text-sm sm:leading-5"
            >
              <option value="" disabled>Selecciona un acabado</option>
              <option
                v-for="slabExteriorFinish in sortedComposite"
                :key="slabExteriorFinish.id"
                :value="slabExteriorFinish.id"
                >{{ slabExteriorFinish.name }}</option
              >
            </select>
            <div
              class="absolute inset-y-0 right-0 pr-8 flex items-center pointer-events-none"
              v-if="$v.form.slab_exterior_finishes.$error"
            >
              <svg
                class="h-5 w-5 text-red-500"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd"
                />
              </svg>
            </div>
          </div>
        </div>
        <!-- End slab -->
        <div class="justify-end flex mt-2 w-full">
          <button
            type="button"
            @click="$emit('cancel-adding-scenario')"
            class="inline-flex items-center px-4 py-2 border border-suma text-sm leading-5 font-medium rounded-md text-suma bg-white hover:bg-suma hover:text-white focus:outline-none focus:shadow-outline-indigo focus:border-transparent transition duration-150 ease-in-out mr-2"
          >
            Cancelar
          </button>

          <button
            type="button"
            @click="addScenario"
            class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-suma hover:bg-indigo-500 focus:outline-none focus:shadow-outline-indigo focus:border-indigo-600 transition duration-150 ease-in-out"
          >
            <svg
              class="-ml-1 mr-2 h-5 w-5"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              ></path>
            </svg>
            Agregar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

function boolean(value) {
  return typeof value === 'boolean';
}

function inArray(array) {
  return function(value) {
    return array.includes(value);
  };
}

function optionalInArray(array) {
  return function(value) {
    if (value != '') {
      return array.includes(value);
    }
    return true;
  };
}

export default {
  props: {
    doorsOptions: {},
    material: {},
    lastScenario: {},
  },
  computed: {
    sortedWallMaterials() {
      let wallMaterials = this.material.walls;
      let sortedWallMaterials = wallMaterials.sort((a, b) =>
        a.name > b.name ? 1 : -1
      );

      return sortedWallMaterials;
    },
    sortedWindowMaterials() {
      let windowMaterials = this.material.windows;
      let sortedWindowMaterials = windowMaterials.sort((a, b) =>
        a.name > b.name ? 1 : -1
      );

      return sortedWindowMaterials;
    },
    sortedDoorMaterials() {
      let doorMaterials = this.material.doors;
      let sortedDoorMaterials = doorMaterials.sort((a, b) =>
        a.name > b.name ? 1 : -1
      );

      return sortedDoorMaterials;
    },
    sortedComposite() {
      let composite = this.material.composite;
      let sortedComposite = composite.sort((a, b) =>
        a.name > b.name ? 1 : -1
      );

      return sortedComposite;
    },
    sortedSlabMaterials() {
      let slabMaterials = this.material.slabs;
      let sortedSlabMaterials = slabMaterials.sort((a, b) =>
        a.name > b.name ? 1 : -1
      );

      return sortedSlabMaterials;
    },
  },
  data() {
    let scenario = this.lastScenario;
    return {
      form: {
        doors_are_made_of_glass: scenario ? scenario.doors_are_made_of_glass : false,
        doors_material: scenario ? scenario.doors_material : '',
        glass_material: scenario ? scenario.glass_material : '',
        wall_material: scenario ? scenario.wall_material : '',
        wall_interior_finishes: scenario ? scenario.wall_interior_finishes : '',
        wall_exterior_finishes: scenario ? scenario.wall_exterior_finishes : '',
        slab_material: scenario ? scenario.slab_material : '',
        slab_interior_finishes: scenario ? scenario.slab_interior_finishes : '',
        slab_exterior_finishes: scenario ? scenario.slab_exterior_finishes : '',
      },
    };
  },
  validations() {
    if (this.form.doors_are_made_of_glass) {
      return {
        form: {
          doors_are_made_of_glass: {
            required,
            boolean,
          },
          glass_material: {
            required,
            inGlassMaterialsArray: inArray([
              ...new Set(this.material.windows.map((a) => a.id)),
            ]),
          },
          wall_material: {
            required,
            inWallsMaterialsArray: inArray([
              ...new Set(this.material.walls.map((a) => a.id)),
            ]),
          },
          wall_interior_finishes: {
            inFinishesArray: optionalInArray([
              ...new Set(this.material.composite.map((a) => a.id)),
            ]),
          },
          wall_exterior_finishes: {
            inFinishesArray: optionalInArray([
              ...new Set(this.material.composite.map((a) => a.id)),
            ]),
          },
          slab_material: {
            inSlabMaterialsArray: inArray([
              ...new Set(this.material.slabs.map((a) => a.id)),
            ]),
          },
          slab_interior_finishes: {
            inFinishesArray: optionalInArray([
              ...new Set(this.material.composite.map((a) => a.id)),
            ]),
          },
          slab_exterior_finishes: {
            inFinishesArray: optionalInArray([
              ...new Set(this.material.composite.map((a) => a.id)),
            ]),
          },
        },
      };
    } else {
      return {
        form: {
          doors_are_made_of_glass: {
            required,
            boolean,
          },
          doors_material: {
            required,
            inDoorsMaterialsArray: inArray([
              ...new Set(this.material.doors.map((a) => a.id)),
            ]),
          },
          glass_material: {
            required,
            inGlassMaterialsArray: inArray([
              ...new Set(this.material.windows.map((a) => a.id)),
            ]),
          },
          wall_material: {
            required,
            inWallsMaterialsArray: inArray([
              ...new Set(this.material.walls.map((a) => a.id)),
            ]),
          },
          wall_interior_finishes: {
            inFinishesArray: optionalInArray([
              ...new Set(this.material.composite.map((a) => a.id)),
            ]),
          },
          wall_exterior_finishes: {
            inFinishesArray: optionalInArray([
              ...new Set(this.material.composite.map((a) => a.id)),
            ]),
          },
          slab_material: {
            inSlabMaterialsArray: inArray([
              ...new Set(this.material.slabs.map((a) => a.id)),
            ]),
          },
          slab_interior_finishes: {
            inFinishesArray: optionalInArray([
              ...new Set(this.material.composite.map((a) => a.id)),
            ]),
          },
          slab_exterior_finishes: {
            inFinishesArray: optionalInArray([
              ...new Set(this.material.composite.map((a) => a.id)),
            ]),
          },
        },
      };
    }
  },
  methods: {
    addScenario() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('scenario-added', this.form);
      }
    },
  },
};
</script>
